import { LocationPage } from "@/components/locations/LocationPage";
import { getLocationBySlug } from "@/data/locations";

const BookkeepingServicesPretoria = () => {
  const location = getLocationBySlug("pretoria")!;
  return <LocationPage location={location} />;
};

export default BookkeepingServicesPretoria;
